// src/builtInPhotos.js
//
// Generated by functions/scripts/buildPhotos.js from assets/photos — do not
// edit by hand; change the originals and run the script again.
//
// The photos that ship with the site. A product with no photos of its own in
// the admin dashboard shows the ones listed for it here, and the site's
// background is the farm photo until another is uploaded.

/** Each photo by key: its size, an inline blurred placeholder, and its widths. */
export const BUILT_IN_PHOTOS = {
  "eragrostis-1": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRqgAAABXRUJQVlA4IJwAAADQBACdASoYABgAPu1urlKppiQiqAgBMB2JZQDKBa0AdC93HF562j0Mf2usETfQAAD88+ER1l0i/hd4NMy64hu7X8BtglyqD4ymDuKXW91Z2wb5kOM5qpvQVcmMwFigx0OXAb0RyF35Y7s6ge9jx+t9gtdi1HSv/aafR7rtSogbU1XiAYCamZuyqXG0o1qaf7QS82cJs3uE7+wAAAA=",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/eragrostis-1.320.4befb9b6ff.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/eragrostis-1.480.8a539b1c19.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/eragrostis-1.640.650b608bed.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/eragrostis-1.750.61cf183bee.webp"
      }
    ]
  },
  "eragrostis-2": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAACQBACdASoYABgAPu1qqVAppiOiqA1RMB2JYwC7AAU4JpBH4/0bl/Wt5ifrZgAA+1uEpeLMewaEHlGKbXY8JCTCHbk/SdibbeZWU6vDUmokgbgGDtQpgJHkCSMnS6FzBDIxaEBn7cCgpiVqbwdiGg9JK7Ofi7oMbJt+RWEUf56a0CooaosPbTmgZOoAAA==",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/eragrostis-2.320.b4bbe02e9c.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/eragrostis-2.480.d0dde11127.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/eragrostis-2.640.6d38f03ea8.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/eragrostis-2.750.555159b003.webp"
      }
    ]
  },
  "lucerne-1": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRoIAAABXRUJQVlA4IHYAAABwBACdASoYABgAPu1oqU+ppiOiKA1RMB2JZwCyzA9HUrIs7BfKYqEPoefrwAD8bTYlMEXU41fWHxfo6MYEZD06izMfhODYwjhaDVfBgxITnvLQuwcGhoXv1GnAO6cVkFfdEiuMEB5qI7REbWhezYz9PPJUdmAA",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/lucerne-1.320.26d4beddd9.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/lucerne-1.480.046c3fdb59.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/lucerne-1.640.ab6e6bac26.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/lucerne-1.750.d3d79366db.webp"
      }
    ]
  },
  "oats-1": {
    "width": 960,
    "height": 720,
    "placeholder": "data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAACQBACdASoYABIAPu1sq1EppaOiqAqpMB2JYwCdM2QAExIfT8X0y6tc03OYJQAA9hofBT+gAw+UoiTvLSwNkh4AIY5cm6KkYh5G3qWoLtn+5PeAkQir0+DGW3ZHYQpEPYoyoHsZ4mg/oBSw0NTCe76vdKIMj+WrwjhLUV++Bo6f/OnyRklYBdfH0yhjgYKCMwAAAA==",
    "variants": [
      {
        "width": 320,
        "height": 240,
        "url": "/img/products/oats-1.320.6083fb3c56.webp"
      },
      {
        "width": 480,
        "height": 360,
        "url": "/img/products/oats-1.480.e72c1b2bf1.webp"
      },
      {
        "width": 640,
        "height": 480,
        "url": "/img/products/oats-1.640.c91b6fae77.webp"
      },
      {
        "width": 800,
        "height": 600,
        "url": "/img/products/oats-1.800.b57532730e.webp"
      },
      {
        "width": 960,
        "height": 720,
        "url": "/img/products/oats-1.960.bd757deab3.webp"
      }
    ]
  },
  "oats-2": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRsgAAABXRUJQVlA4ILwAAABQBQCdASoYABgAPu1urlIppiQiqAgBMB2JZQCnFYyKTE4mqOa1oQuTC0C1HBGtrZ1zfgAA/oIK2U5MjNjiahOhfWGaqxwVj8u7tBroZedCh9P9WllrlPBVtv5aDZQEbCbaWncnEpQDDHaBaZS5NascszX68GZvuttZGp/qAUGFNdZEYqOcV0O7XkUYbJ3za3cXdrSqQAr9yjknSEDFUEdYe0/scMB/yg/jnsomitgEL37QaCrm5DoTFAAAAA==",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/oats-2.320.1f7576c0a1.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/oats-2.480.fe2bfb7f27.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/oats-2.640.7eb48b5776.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/oats-2.750.16114f48ea.webp"
      }
    ]
  },
  "oats-3": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRrIAAABXRUJQVlA4IKYAAADQBACdASoYABgAPtFWok2oJKMiN+gBABoJYwCw7CpMWQJ7qoJmWeM5ekTrx/t8AADMULJh7ZIvTGV1IQZPUPElmzXqjTFQLoUWjh3+WZwr2XbKBPxYtUnHNrQh6oFY6RUkutLz0C0spVmwyEHbs9L4bnES3tsKfwAMvB+Qu6M6hXYepFw2O6/Rhwc0+86I3R5MnATANUvi0eIIBio+wUX3WmxAAAAA",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/oats-3.320.f93b680bc2.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/oats-3.480.b898f756e7.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/oats-3.640.4b08288f25.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/oats-3.750.47245ab368.webp"
      }
    ]
  },
  "shavings-1": {
    "width": 461,
    "height": 461,
    "placeholder": "data:image/webp;base64,UklGRroAAABXRUJQVlA4IK4AAADwBACdASoYABgAPu1ur1IppiQiqAgBMB2JZQDA3BBVtgMwCNfH92jFbMhROY4zQpAAzaFlJ6z5awUa/S1+VtWjp3WBH+frIdo9Fvni9b4KGrONDEz/3wjfvTw6ZdIWk65KSWxKYCK+jFckEQOyf6/FXtDo2KlhGrM9N8L9Ss+PNv2S9N8q7C5xcVjIMJuPZZzfocsTJQEx9TKbVZHG7CTBoCM65FuQPxL0xMgAAAA=",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/shavings-1.320.e11f8977bd.webp"
      },
      {
        "width": 461,
        "height": 461,
        "url": "/img/products/shavings-1.461.fa8b06e2e4.webp"
      }
    ]
  },
  "teffGradeA-1": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRqwAAABXRUJQVlA4IKAAAABwBACdASoYABgAPu1ur1IppiQiqAgBMB2JYwClrAw6vILJ9Ze2uctNX9zc0AD+Twyod9oIPjJdwjIy8i78UlL2jrxdzEMyRhoDahtWgkH55D/nDSa3BNL2EK4SV2EXJm7QXQTQOb2SCEESm7atgnf+vF4R9yn7+dcAte9BclFEa9Ioo2RPCTLpXiTaaE2/EybPoY2SckHn0mXCTjMhHQAA",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/teffGradeA-1.320.609d8370ef.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/teffGradeA-1.480.de2cd74c43.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/teffGradeA-1.640.a04ac2dfc2.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/teffGradeA-1.750.d36eeb65ff.webp"
      }
    ]
  },
  "teffGradeA-2": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAACwBACdASoYABgAPu1oqU+ppaOiKA1RMB2JZwAAInDQHozFhyxhtGzaf5vz49IAAPlaio4FTUMgq52hg368dqQwBXkuaocf7ICnxG1KLFqY++bEgatsmKGk2lRDu+8y/NAquaKXf/G4RLVO9m6xBNAwSwRpe1+wbChIf+Wxx4AkENTBMQQUWIMb8jsAAA==",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/teffGradeA-2.320.e61754a850.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/teffGradeA-2.480.4831f1c102.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/teffGradeA-2.640.e2d59df0e6.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/teffGradeA-2.750.2a74944ac2.webp"
      }
    ]
  },
  "teffGradeB-1": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRroAAABXRUJQVlA4IK4AAAAwBQCdASoYABgAPu1srVIppaQiqAgBMB2JYwCdMsdBNtV+xeAZSJ+e+UlN7tkv1jmOQAD+3G5k3KqJV8cv8wKjy0enok99gtbtm0BQiNLu42aWO81ntOUwBhn3owkYOBT/6+MbyeG0TAz+sh/yl/pMWxOXDNr6ePDxmhL/HpCGRmVDpOX7WeYj/KYsxfQUqEYoFDESz4qJ9/tIU6U7ZlKi9fyEzjt5oqmASiyX4AA=",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/teffGradeB-1.320.9f1a3e0072.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/teffGradeB-1.480.36834f9b31.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/teffGradeB-1.640.b25553b93e.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/teffGradeB-1.750.b112411abe.webp"
      }
    ]
  },
  "teffGradeB-2": {
    "width": 750,
    "height": 750,
    "placeholder": "data:image/webp;base64,UklGRp4AAABXRUJQVlA4IJIAAACQBACdASoYABgAPu1urVKppiQiqAgBMB2JZzIbwyDgLJmDq+l9rRDb0f8YJGAA/f5oE128APPMENgqzcPXcnzFIcHZIedzXxk51720b0U4Hf38VnXEo9WQwQkWMqSLIo5BcCbpgpvGGE26pG1iKj4Fcmp+6WPvQN5MByPjDNb1PJZOPBTtSPcP/rLTVut/yZAAAA==",
    "variants": [
      {
        "width": 320,
        "height": 320,
        "url": "/img/products/teffGradeB-2.320.d20e7b8535.webp"
      },
      {
        "width": 480,
        "height": 480,
        "url": "/img/products/teffGradeB-2.480.8b1f4a4afb.webp"
      },
      {
        "width": 640,
        "height": 640,
        "url": "/img/products/teffGradeB-2.640.215bca3739.webp"
      },
      {
        "width": 750,
        "height": 750,
        "url": "/img/products/teffGradeB-2.750.de2bfa2d8c.webp"
      }
    ]
  },
  "farm": {
    "width": 1920,
    "height": 1080,
    "placeholder": "data:image/webp;base64,UklGRoQAAABXRUJQVlA4IHgAAAAwBACdASoYAA4APu1iqU2ppaOiMAgBMB2JbACdMoGv/gJcsPxkuDGTSbAA/FRWB7FGSh3RtrdXWn2geSx+3AmMBwrT1z9vbPkP2BP3b7eFNEhPQRIwy/HDwk0uKpDK57DxozBMoafeFz4JrK0fsvgftn6yeGeBQAA=",
    "variants": [
      {
        "width": 1280,
        "height": 720,
        "url": "/img/site/farm.1280.15f0dff17d.webp"
      },
      {
        "width": 1920,
        "height": 1080,
        "url": "/img/site/farm.1920.178e405407.webp"
      }
    ]
  }
};

/** The built-in photos for each product, by its photoKey, cover first. */
export const BUILT_IN_PRODUCT_PHOTOS = {
  "eragrostis": [
    "eragrostis-1",
    "eragrostis-2"
  ],
  "lucerne": [
    "lucerne-1"
  ],
  "oats": [
    "oats-1",
    "oats-2",
    "oats-3"
  ],
  "shavings": [
    "shavings-1"
  ],
  "teffGradeA": [
    "teffGradeA-1",
    "teffGradeA-2"
  ],
  "teffGradeB": [
    "teffGradeB-1",
    "teffGradeB-2"
  ]
};

/** The built-in photo for each of the site's own photos, by slot. */
export const BUILT_IN_SITE_PHOTOS = { hero: "farm" };
